import { ChartLine } from 'lucide-react';
import { useRecordContext, useTranslate } from 'ra-core';
import { useHasPermission } from '../../auth/useHasPermission';
import { DataTable } from '../../components/admin/data-table';
import { ActionLink } from '../../components/custom/ActionLink';
import { RowActions } from '../../components/custom/RowActions';
import { MoonstarList } from '../Moonstar/MoonstarList';
import { MoonstarListBulkActions } from '../Moonstar/MoonstarListBulkActions';

export const UnitList = () => {
  const hasPerformIQAccess = useHasPermission('PERFORM_IQ_KPIS_ACCESS');

  return (
    <MoonstarList sort={{ field: 'name', order: 'ASC' }}>
      <DataTable
        rowClick="edit"
        bulkActionButtons={<MoonstarListBulkActions />}
      >
        <DataTable.Col source="name" />
        {hasPerformIQAccess && (
          <DataTable.Col className="w-px whitespace-nowrap">
            <ViewPerformanceButton />
          </DataTable.Col>
        )}
      </DataTable>
    </MoonstarList>
  );
};

const ViewPerformanceButton = () => {
  const record = useRecordContext();
  const translate = useTranslate();

  if (!record) {
    return null;
  }

  return (
    <RowActions>
      <ActionLink to={`/units/${record.id}/performance`} icon={<ChartLine />}>
        {translate('resources.units.fields.performance')}
      </ActionLink>
    </RowActions>
  );
};
